import React__default from 'react';
import { __rest, __assign } from '../../../../_virtual/_tslib.js';
import { Button } from '@deal/components';
import classnames from 'classnames';
import styles from './styles.css.js';

var CallToAction = function CallToAction(_a) {
  var _b;

  var className = _a.className,
      onClick = _a.onClick,
      children = _a.children,
      props = __rest(_a, ["className", "onClick", "children"]);

  return React__default.createElement(Button, __assign({
    variant: "primary-light",
    className: classnames(styles.cta, (_b = {}, _b[styles.activeCta] = !!onClick, _b), className),
    onClick: onClick
  }, props), children);
};

export default CallToAction;
//# sourceMappingURL=index.js.map
